export type InstrumentCategory = 'STRINGS' | 'KEYS' | 'PERCUSSION' | 'VOCALS' | 'OPERATIONS' | 'OTHER';

export const CATEGORY_LABELS: Record<InstrumentCategory, string> = {
  STRINGS: 'Cordas',
  KEYS: 'Teclas',
  PERCUSSION: 'Percussão',
  VOCALS: 'Vocais',
  OPERATIONS: 'Operações',
  OTHER: 'Outros',
};

export interface Instrument {
  id: string;
  name: string;
  category: InstrumentCategory;
  is_global: boolean;
  is_active: boolean;
}

export interface MemberInstrument {
  id: string;
  instrument_id: string;
  instrument_name: string;
  instrument_category: InstrumentCategory;
  is_primary: boolean;
}
